"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.combineRGBA = void 0;
var convertRGBAToArray = function (rgbaValue) {
    return rgbaValue
        .replace('rgba(', '')
        .replace(')', '')
        .replace(' ', '')
        .split(',')
        .map(function (value, index) { return (index < 3 ? parseInt(value, 10) : parseFloat(value)); });
};
var combineRGBA = function (baseRGBA, addedRGBA) {
    var base = convertRGBAToArray(baseRGBA);
    var added = convertRGBAToArray(addedRGBA);
    var mix = [];
    /* NOTE: Alpha */
    mix[3] = 1 - (1 - added[3]) * (1 - base[3]);
    /* NOTE: Red */
    mix[0] = Math.round((added[0] * added[3]) / mix[3] + (base[0] * base[3] * (1 - added[3])) / mix[3]);
    /* NOTE: Green */
    mix[1] = Math.round((added[1] * added[3]) / mix[3] + (base[1] * base[3] * (1 - added[3])) / mix[3]);
    /* NOTE: Blue */
    mix[2] = Math.round((added[2] * added[3]) / mix[3] + (base[2] * base[3] * (1 - added[3])) / mix[3]);
    return "rgba(".concat(mix[0], ", ").concat(mix[1], ", ").concat(mix[2], ", ").concat(mix[3], ")");
};
exports.combineRGBA = combineRGBA;
//# sourceMappingURL=combine-rgba.js.map